import { render, staticRenderFns } from "./NavigationUsersButtons.vue?vue&type=template&id=2523d3b5&scoped=true&"
import script from "./NavigationUsersButtons.vue?vue&type=script&lang=js&"
export * from "./NavigationUsersButtons.vue?vue&type=script&lang=js&"
import style0 from "./NavigationUsersButtons.vue?vue&type=style&index=0&id=2523d3b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523d3b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
